import React from 'react';
import Styles from './checking-account-styles.scss';
import { useChecking } from '../hooks/use-checking';
import { Table, ExpensesModal, TabHeader, HeaderMenu } from '@/presentation/components';
import TableNotFound from '@/presentation/components/table/table-not-found/table-not-found';
import CheckingAccountOverview from './overview/checking-account-overview';
import { transactionTableState } from './components/atoms';
import { useRecoilState } from 'recoil';
import useTransactionTable from './hooks/useTransactionTable';
import { useNavigate } from 'react-router';
import useStudentAccounts from '@/presentation/hooks/use-student-accounts';
const CheckingAccount = ({ virtualTransactions, validationTransferFunds, manageVirtualTransactions }) => {
    const { chartData, total, loading } = useChecking({ virtualTransactions });
    const [state, setState] = useRecoilState(transactionTableState);
    const navigate = useNavigate();
    const { checkingAccount } = useStudentAccounts(false);
    const { columns, columnsWithoutSort, getTransactionsPaginated, renderCellByType } = useTransactionTable({
        mainTableState: transactionTableState,
        manageVirtualTransactions,
        virtualAccountIds: [checkingAccount === null || checkingAccount === void 0 ? void 0 : checkingAccount.id]
    });
    return (React.createElement("div", { className: Styles.mainWrap },
        React.createElement("div", { style: { padding: '1rem 0rem 0rem 2rem' } },
            React.createElement(HeaderMenu, { title1: "My wallet", title2: "Checking Account", onBack: () => navigate(`/student-dashboard/my-wallet/overview`) })),
        React.createElement("div", { className: Styles.checkingAccountContainer },
            React.createElement("div", { className: Styles.checking },
                React.createElement(CheckingAccountOverview, { validationTransferFunds: validationTransferFunds, manageVirtualTransactions: manageVirtualTransactions, onTransferCompleted: () => setState(prev => (Object.assign(Object.assign({}, prev), { reloadTransactions: !prev.reloadTransactions }))) })),
            React.createElement("div", { className: Styles.chart },
                React.createElement(ExpensesModal, { total: total, loading: loading, items: chartData, chartWidth: "100%", chartHeight: "100%" }))),
        React.createElement("div", { className: Styles.table },
            React.createElement(TabHeader, { title: "Transaction History" }),
            React.createElement(Table, { columns: columns, data: state.transactions.data, 
                // dataNotFound={state.dataNotFound}
                DataNotFoundComponent: () => {
                    return React.createElement(DataNotFoundComp, null);
                }, columnsWithoutSort: columnsWithoutSort, renderCellByType: renderCellByType, pagination: {
                    total: state.transactions.total,
                    page: state.transactions.page,
                    count: state.transactions.count,
                    pageCount: state.transactions.pageCount
                }, fetchData: (pagination, sort) => {
                    getTransactionsPaginated(state.filters, pagination, sort);
                }, filters: state.filters, loading: state.isTableLoading })),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null)));
};
const DataNotFoundComp = () => {
    // const [state, setState] = useRecoilState(manageStudentsAtom);
    return (React.createElement(TableNotFound
    /*
    onClick={() => {
      setState(prev => {
        return {
          ...prev,
          filters: {
            input: '',
            deleted: false
          },
          dataNotFound: false
        };
      });
    }}
    term={state.filters.input !== '' ? state.filters.input : null}
    */
    , { 
        /*
        onClick={() => {
          setState(prev => {
            return {
              ...prev,
              filters: {
                input: '',
                deleted: false
              },
              dataNotFound: false
            };
          });
        }}
        term={state.filters.input !== '' ? state.filters.input : null}
        */
        onClick: () => console.log('0'), term: "NOT FOUND" }));
};
export default CheckingAccount;
